// ================================================================================
// Custom events
//
// To help make it easier to add custom functionality, the theme emits custom
// events (along with their associated data) related to key theme features.
//
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.
// ================================================================================

/* eslint-disable no-console */

// ================================================================================
// "Item added to the cart"
//
// - Fires whenever an item has been added to the cart
// - Exposed when the ajax cart is enabled
// - "detail" object data:
//   - The associated product object
// ================================================================================
document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);
});

// ================================================================================
// "Cart updated"
//
// - Fires whenever the cart is updated
// - Exposed when the ajax cart is enabled
// - "detail" object data:
//   - The cart object
// ================================================================================
document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);
});

// ================================================================================
// "Cart error"
//
// - Fires whenever there is an error when adding an item to the cart
//   - Typically due to a product not having sufficient stock
// - "detail" object data:
//   - The error message
// ================================================================================
document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
});

// ================================================================================
// "Quick cart opened"
//
// - Fires whenever the quick cart is opened
// - Exposed when the ajax cart is enabled
// - "detail" object data:
//   - The cart object
// ================================================================================
document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
});

// ================================================================================
// "Quick cart closed"
//
// - Fires whenever the quick cart is opened
// - Exposed when the ajax cart is enabled
// ================================================================================
document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
});

// ================================================================================
// "Product variant changed"
//
// - Fires whenever a variant product is selected
// - Exposed when a 'Variant selectors' block has been added to a product template
//   or featured product section
// - "detail" object data:
//   - The variant object
// ================================================================================
document.addEventListener("product:variant-change", function (evt) {
  console.log("Product variant changed");
  console.log(evt.detail.variant);

  // Sync aria-pressed on variant option buttons to match selected class
  document.querySelectorAll(".product__chip[data-option-handle]").forEach(function (btn) {
    btn.setAttribute("aria-pressed", btn.classList.contains("selected"));
  });
});

// ================================================================================
// "Product quantity updated"
//
// - Fires whenever a product quanatiy is updated
// - Exposed when a 'Quantity selector' block has been added to a product template
//   or featured product section
// - "detail" object data:
//   - The variant object
//   - The quantity
// ================================================================================
document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);

  // Announce new quantity to screen readers via <output> live region
  var output = document.querySelector("[data-quantity-output]");
  if (output) {
    output.textContent = evt.detail.quantity;
    clearTimeout(output._clearTimer);
    output._clearTimer = setTimeout(function () {
      output.textContent = "";
    }, 2000);
  }
});

// ================================================================================
// "Quick view loaded"
//
// - Fires whenever a quick view modal is opened
// - Exposed when the 'Enable quick view' setting is enabled and a quick view
//   modal is opened
// ================================================================================
document.addEventListener("quick-view:loaded", function () {
  console.log("Quick view loaded");
});
/* eslint-enable no-console */

// ================================================================================
// Video play/pause button aria-label sync
//
// theme.js toggles data-is-playing on .video-pause-floating on click.
// We keep aria-label in sync by toggling it on click, independent of
// listener order.
// ================================================================================
(function initVideoPauseAccessibility() {
  function initVideoButtons(container) {
    container.querySelectorAll(".video-pause-floating").forEach(function (btn) {
      // Product gallery pause buttons are fully managed by
      // initProductMediaVideoPause below (label + play/pause state are driven
      // by the video itself); skip them here to avoid double-toggling.
      if (btn.closest(".product__media-item")) return;

      // Sync initial label — data-is-playing may already be "false" if
      // theme.js called pauseVideo() for prefersReducedMotion on init.
      btn.setAttribute("aria-label", btn.dataset.isPlaying === "true" ? "Pause video" : "Play video");

      btn.addEventListener("click", function () {
        btn.setAttribute("aria-label", btn.getAttribute("aria-label") === "Pause video" ? "Play video" : "Pause video");
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { initVideoButtons(document); });
  } else {
    initVideoButtons(document);
  }

  document.addEventListener("shopify:section:load", function (evt) {
    initVideoButtons(evt.target);
  });
})();

// ================================================================================
// Product gallery video — floating pause button + state sync
//
// The product media gallery renders native videos as muted, looping,
// autoplaying "ambiance" videos with no native controls (see the
// `ambiance_video` branch in snippets/media.liquid), matching the product
// tabs video block. theme.js's featuredVideoHandler only wires the tabs
// block, so we own the gallery's floating pause buttons here.
//
// We mirror the video's REAL play/pause state onto the button (data-is-playing
// drives the icon, aria-label the screen-reader text) by listening to the
// video's own play/pause events. That keeps the button in sync no matter what
// changes the state — a button click, a carousel slide change, or a variant
// swap that re-renders the media.
// ================================================================================
(function initProductMediaVideoPause() {
  var PLAYING_LABEL = "Pause video";
  var PAUSED_LABEL = "Play video";

  function syncButton(video, btn) {
    var playing = !video.paused;
    btn.dataset.isPlaying = playing ? "true" : "false";
    btn.setAttribute("aria-label", playing ? PLAYING_LABEL : PAUSED_LABEL);
  }

  function wireMediaItem(mediaItem) {
    var video = mediaItem.querySelector("video");
    var btn = mediaItem.querySelector(".video-pause-floating");
    if (!video || !btn || video.dataset.pauseWired === "true") return;
    video.dataset.pauseWired = "true";

    video.addEventListener("play", function () { syncButton(video, btn); });
    video.addEventListener("pause", function () { syncButton(video, btn); });

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      video.pause();
    }
    syncButton(video, btn);
  }

  function wireAll(root) {
    (root || document)
      .querySelectorAll(".product__media-item")
      .forEach(wireMediaItem);
  }

  // Delegated click — also covers buttons added later via AJAX variant swaps.
  document.addEventListener("click", function (e) {
    var btn = e.target.closest(".video-pause-floating");
    if (!btn) return;
    var mediaItem = btn.closest(".product__media-item");
    if (!mediaItem) return; // tab-block buttons are handled by theme.js
    var video = mediaItem.querySelector("video");
    if (!video) return;
    e.preventDefault();
    if (video.paused) {
      video.play();
    } else {
      video.pause();
    }
    // play/pause listeners update the button; sync now as a fallback in case
    // play() rejects (it shouldn't for muted video) so the icon never lies.
    syncButton(video, btn);
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { wireAll(document); });
  } else {
    wireAll(document);
  }
  document.addEventListener("shopify:section:load", function (evt) { wireAll(evt.target); });
  document.addEventListener("product:variant-change", function () {
    // Media may be re-rendered after a variant change; wire any new videos.
    setTimeout(function () { wireAll(document); }, 300);
  });
})();

// ================================================================================
// Tabbed collections accessibility enhancement
//
// Syncs aria-selected state with the selected class for screen reader support.
// ================================================================================
(function initTabbedCollectionsAccessibility() {
  function syncTabbedCollectionStates(tabButton) {
    const isSelected = tabButton.classList.contains("selected");
    tabButton.setAttribute("aria-selected", isSelected ? "true" : "false");
  }

  function initTabbedCollections(container) {
    const tabButtons = container.querySelectorAll('[data-section-type="tabbed-collections"] [data-tab-button]');

    tabButtons.forEach(function (tabButton) {
      syncTabbedCollectionStates(tabButton);

      const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.attributeName === "class") {
            syncTabbedCollectionStates(tabButton);
          }
        });
      });

      observer.observe(tabButton, { attributes: true });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initTabbedCollections(document);
    });
  } else {
    initTabbedCollections(document);
  }

  document.addEventListener("shopify:section:load", function (evt) {
    initTabbedCollections(evt.target);
  });
})();

// ================================================================================
// Accessibility enhancements for cart button
// Rebuy manages the cart, so use its events for cart accessibility
// ================================================================================

// When Rebuy is ready, the cart link becomes a button (opens Rebuy's drawer)
document.addEventListener("rebuy:smartcart.ready", function () {
  document.querySelectorAll("[data-header-cart]").forEach(function (trigger) {
    trigger.setAttribute("role", "button");
    trigger.setAttribute("aria-expanded", "false");
    trigger.addEventListener("keydown", function (event) {
      if (event.key === " ") {
        event.preventDefault();
        trigger.click();
      }
    });
  });
});

// Open the mini cart after a cart-page redirect (e.g. "Buy Again" from account)
// The cart template front-runs Rebuy's cart-page redirect (in <head>) to avoid a
// flash of the cart page, then flags that the drawer should open on landing here.
document.addEventListener("rebuy:smartcart.ready", function () {
  if (!sessionStorage.getItem("openCartOnLoad")) return;
  sessionStorage.removeItem("openCartOnLoad");

  if (
    window.Rebuy &&
    window.Rebuy.SmartCart &&
    typeof window.Rebuy.SmartCart.show === "function"
  ) {
    window.Rebuy.SmartCart.show();
  } else {
    // Fallback: the header cart trigger opens Rebuy's drawer once ready
    var trigger = document.querySelector("[data-header-cart]");
    if (trigger) trigger.click();
  }
});

// Toggle aria-expanded when Rebuy's cart drawer opens/closes
document.addEventListener("rebuy:smartcart.show", function () {
  document.querySelectorAll("[data-header-cart]").forEach(function (trigger) {
    trigger.setAttribute("aria-expanded", "true");
  });
});
document.addEventListener("rebuy:smartcart.hide", function () {
  document.querySelectorAll("[data-header-cart]").forEach(function (trigger) {
    trigger.setAttribute("aria-expanded", "false");
  });
});

// Update the cart status live region when the cart changes
document.addEventListener("rebuy:cart.change", function (evt) {
  var count = evt.detail.cart.itemCount();
  document.querySelectorAll("[data-cart-status]").forEach(function (output) {
    output.querySelector("[data-cart-status-count]").textContent =
      count === 1 ? "1 item" : count + " items";
  });
});

// ================================================================================
// Accessibility enhancements for search buttons
// ================================================================================
(function () {
  function getSearchTriggers() {
    // Only header search triggers; faux-inputs are handled by individual quickSearchObservers
    return document.querySelectorAll("[data-search-trigger]");
  }

  // Search triggers are links by default (with no-JS functionality in mind).
  // JS turns them into triggers, so the semantics need updated to match.
  getSearchTriggers().forEach(function (trigger) {
    trigger.setAttribute("role", "button");

    // <a> doesn't activate on Space natively; buttons should
    trigger.addEventListener("keydown", function (event) {
      if (event.key === " ") {
        event.preventDefault();
        trigger.click();
      }
    });
  });

  function updateSearchAriaExpanded(isOpen) {
    getSearchTriggers().forEach(function (trigger) {
      trigger.setAttribute("aria-expanded", isOpen ? "true" : "false");
    });
  }
  updateSearchAriaExpanded(false);

  // Watch for data-quick-search-open attribute changes on body
  var bodyObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "data-quick-search-open"
      ) {
        var isOpen = document.body.dataset.quickSearchOpen === "true";
        updateSearchAriaExpanded(isOpen);
      }
    });
  });
  bodyObserver.observe(document.body, {
    attributes: true,
    attributeFilter: ["data-quick-search-open"],
  });

  // Also watch for data-quick-search-active attribute changes on quick-search elements
  var quickSearchElements = document.querySelectorAll("[data-quick-search]");
  quickSearchElements.forEach(function (quickSearchEl) {
    var fauxInput = quickSearchEl.querySelector("[data-quick-search-faux-input]");
    if (fauxInput) {
      fauxInput.setAttribute("aria-expanded", "false");
    }

    var quickSearchObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "data-quick-search-active"
        ) {
          var isActive = quickSearchEl.dataset.quickSearchActive === "true";
          // Update only the faux-input within this quick-search element
          var fauxInput = quickSearchEl.querySelector(
            "[data-quick-search-faux-input]"
          );
          if (fauxInput) {
            fauxInput.setAttribute("aria-expanded", isActive ? "true" : "false");
          }
        }
      });
    });
    quickSearchObserver.observe(quickSearchEl, {
      attributes: true,
      attributeFilter: ["data-quick-search-active"],
    });
  });
})();
